export const loadFlags = [
  { label: 'Yes', value: true },
  { label: 'No', value: false}
]
